module.exports = __webpack_public_path__ + "media/images/emblems/Signau-coat_of_arms-35e19023abc1ba785cd46caa4801924a.svg";